import {Parameter} from "MeasurementsCalculations";

export class ShotViewerHelper{

    // Static functions
    static displayMaxLength(maxLength: number) {
        if (maxLength < 5) {
            return 5;
        }
        else if (maxLength < 10) {
            return 10;
        }
        else if (maxLength < 20) {
            return 20;
        }
        else if (maxLength < 30) {
            return 30;
        }
        else if (maxLength < 40) {
            return 40;
        }
        else if (maxLength < 60) {
            return 60;
        }
        else if (maxLength < 80) {
            return 80;
        }
        else if (maxLength < 100) {
            return 100;
        }
        else if (maxLength < 150) {
            return 150;
        }
        else if (maxLength < 200) {
            return 200;
        }
        else if (maxLength < 250) {
            return 250;
        }
        else if (maxLength < 300) {
            return 300;
        }
        else if (maxLength < 350) {
            return 350;
        }
        else if (maxLength < 400) {
            return 400;
        }
        return maxLength;
    }

   static displayMaxLengthEuropean(maxLength: number) {
        if (maxLength < 2) {
            return 2;
        }
        if (maxLength < 3) {
            return 3;
        }
        if (maxLength < 5) {
            return 5;
        }
        else if (maxLength < 10) {
            return 10;
        }
        else if (maxLength < 20) {
            return 20;
        }
        else if (maxLength < 30) {
            return 30;
        }
        else if (maxLength < 40) {
            return 40;
        }
        else if (maxLength < 60) {
            return 60;
        }
        else if (maxLength < 80) {
            return 80;
        }
        else if (maxLength < 100) {
            return 100;
        }
        else if (maxLength < 150) {
            return 150;
        }
        else if (maxLength < 200) {
            return 200;
        }
        else if (maxLength < 250) {
            return 250;
        }
        else if (maxLength < 300) {
            return 300;
        }
        else if (maxLength < 350) {
            return 350;
        }
        else if (maxLength < 400) {
            return 400;
        }
        return maxLength;
    }

   static displayMaxLengthUs(maxLength: number) {
        if (maxLength < 6) {
            return 6;
        }
        if (maxLength < 9) {
            return 9;
        }
        if (maxLength < 15) {
            return 15;
        }
        else if (maxLength < 30) {
            return 30;
        }
        else if (maxLength < 60) {
            return 60;
        }
        else if (maxLength < 90) {
            return 90;
        }
        else if (maxLength < 120) {
            return 120;
        }
        else if (maxLength < 180) {
            return 180;
        }
        else if (maxLength < 240) {
            return 240;
        }
        else if (maxLength < 300) {
            return 300;
        }
        else if (maxLength < 450) {
            return 450;
        }
        else if (maxLength < 600) {
            return 600;
        }
        else if (maxLength < 750) {
            return 750;
        }
        else if (maxLength < 900) {
            return 900;
        }
        else if (maxLength < 1050) {
            return 1050;
        }
        else if (maxLength < 1200) {
            return 1200;
        }
        return maxLength;
    }

   static displayMaxHeightEuropean(maxHeight: number) {
        if (maxHeight < 1) {
            return 1;
        }
        if (maxHeight < 2) {
            return 2;
        }
        else if (maxHeight < 3) {
            return 3;
        }
        if (maxHeight < 5) {
            return 5;
        }
        else if (maxHeight < 10) {
            return 10;
        }
        else if (maxHeight < 20) {
            return 20;
        }
        else if (maxHeight < 30) {
            return 30;
        }
        else if (maxHeight < 40) {
            return 40;
        }
        else if (maxHeight < 50) {
            return 50;
        }
        else if (maxHeight < 60) {
            return 60;
        }
        else if (maxHeight < 80) {
            return 80;
        }
        else if (maxHeight < 100) {
            return 100;
        }
        else if (maxHeight < 150) {
            return 150;
        }
        else if (maxHeight < 200) {
            return 200;
        }
        else if (maxHeight < 250) {
            return 250;
        }
        else if (maxHeight < 300) {
            return 300;
        }
        else if (maxHeight < 350) {
            return 350;
        }
        else if (maxHeight < 400) {
            return 400;
        }
        return maxHeight;
    }

   static displayMaxHeightUs(maxHeight: number) {
        if (maxHeight < 3) {
            return 3;
        }
        if (maxHeight < 6) {
            return 6;
        }
        else if (maxHeight < 9) {
            return 9;
        }
        if (maxHeight < 15) {
            return 15;
        }
        else if (maxHeight < 30) {
            return 30;
        }
        else if (maxHeight < 60) {
            return 60;
        }
        else if (maxHeight < 90) {
            return 90;
        }
        else if (maxHeight < 120) {
            return 120;
        }
        else if (maxHeight < 150) {
            return 150;
        }
        else if (maxHeight < 180) {
            return 180;
        }
        else if (maxHeight < 240) {
            return 240;
        }
        else if (maxHeight < 300) {
            return 300;
        }
        else if (maxHeight < 450) {
            return 450;
        }
        else if (maxHeight < 600) {
            return 600;
        }
        else if (maxHeight < 750) {
            return 750;
        }
        else if (maxHeight < 900) {
            return 900;
        }
        else if (maxHeight < 1050) {
            return 1050;
        }
        else if (maxHeight < 1200) {
            return 1200;
        }
        return maxHeight;
    }

   static displayMaxHeight(maxHeight: number) {
        if (maxHeight < 2) {
            return 2;
        }
        if (maxHeight < 5) {
            return 5;
        }
        else if (maxHeight < 10) {
            return 10;
        }
        else if (maxHeight < 20) {
            return 20;
        }
        else if (maxHeight < 30) {
            return 30;
        }
        else if (maxHeight <= 40) {
            return 40;
        }
        else if (maxHeight < 50) {
            return 50;
        }
        else if (maxHeight < 60) {
            return 60;
        }
        else if (maxHeight < 80) {
            return 80;
        }
        else if (maxHeight < 100) {
            return 100;
        }
        else if (maxHeight < 150) {
            return 150;
        }
        else if (maxHeight < 200) {
            return 200;
        }
        else if (maxHeight < 250) {
            return 250;
        }
        else if (maxHeight < 300) {
            return 300;
        }
        else if (maxHeight < 350) {
            return 350;
        }
        else if (maxHeight < 400) {
            return 400;
        }
        return maxHeight;
    }

   static displayTicks(maxLength: number) {
        switch (maxLength) {
            case 5:
                return [1, 2, 3, 4, 5];
            case 10:
                return [2, 4, 6, 8, 10];
            case 20:
                return [5, 10, 15, 20];
            case 40:
                return [10, 20, 30, 40];
            case 60:
                return [10, 20, 30, 40, 50, 60];
            case 80:
                return [10, 20, 30, 40, 50, 60, 70, 80];
            case 100:
                return [20, 40, 60, 80, 100];
            case 150:
                return [20, 40, 60, 80, 100, 150];
            case 200:
                return [20, 40, 60, 80, 100, 150, 200];
            case 250:
                return [20, 40, 60, 80, 100, 150, 200, 250];
            case 300:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300];
            case 350:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350];
            case 400:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400];
            default:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400, maxLength];
        }
    }

   static displayTicksEuropean(maxLength: number) {
        switch (maxLength) {
            case 1:
                return [1];
            case 2:
                return [1, 2];
            case 3:
                return [1, 2, 3];
            case 5:
                return [1, 2, 3, 4, 5];
            case 10:
                return [2, 4, 6, 8, 10];
            case 20:
                return [5, 10, 15, 20];
            case 40:
                return [10, 20, 30, 40];
            case 60:
                return [10, 20, 30, 40, 50, 60];
            case 80:
                return [10, 20, 30, 40, 50, 60, 70, 80];
            case 100:
                return [20, 40, 60, 80, 100];
            case 150:
                return [20, 40, 60, 80, 100, 150];
            case 200:
                return [20, 40, 60, 80, 100, 150, 200];
            case 250:
                return [20, 40, 60, 80, 100, 150, 200, 250];
            case 300:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300];
            case 350:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350];
            case 400:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400];
            default:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400, maxLength];
        }
    }

   static displayTicksUs(maxLength: number) {
        switch (maxLength) {
            case 3:
                return [1, 2, 3];
            case 6:
                return [2, 4, 6];
            case 9:
                return [1, 3, 6, 9];
            case 15:
                return [3, 6, 9, 12, 15];
            case 30:
                return [6, 12, 18, 24, 30];
            case 60:
                return [15, 30, 45, 60];
            case 120:
                return [30, 60, 90, 120];
            case 180:
                return [30, 60, 90, 120, 150, 180];
            case 240:
                return [30, 60, 90, 120, 150, 180, 210, 240];
            case 300:
                return [60, 120, 180, 240, 300];
            case 450:
                return [60, 120, 180, 240, 300, 450];
            case 600:
                return [60, 120, 180, 240, 300, 450, 600];
            case 750:
                return [60, 120, 180, 240, 300, 450, 600, 750];
            case 900:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900];
            case 1050:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900, 1050];
            case 1200:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900, 1050, 1200];
            default:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900, 1050, 1200, maxLength];
        }
    }

   static  displayTicksHeight(maxHeight: number) {
        switch (maxHeight) {
            case 2:
                return [1, 2];
            case 5:
                return [1, 2, 3, 4, 5];
            case 10:
                return [2, 4, 6, 8, 10];
            case 20:
                return [5, 10, 15, 20];
            case 30:
                return [10, 20, 30];
            case 40:
                return [10, 20, 30, 40];
            case 50:
                return [10, 20, 30, 40, 50];
            case 60:
                return [10, 20, 30, 40, 50, 60];
            case 80:
                return [10, 20, 30, 40, 50, 60, 70, 80];
            case 100:
                return [20, 40, 60, 80, 100];
            case 150:
                return [20, 40, 60, 80, 100, 150];
            case 200:
                return [20, 40, 60, 80, 100, 150, 200];
            case 250:
                return [20, 40, 60, 80, 100, 150, 200, 250];
            case 300:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300];
            case 350:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350];
            case 400:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400];
            default:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400, maxHeight];
        }
    }
   static displayTicksHeightEuropean(maxHeight: number) {
        switch (maxHeight) {
            case 1:
                return [1];
            case 2:
                return [1, 2];
            case 3:
                return [1, 2, 3];
            case 5:
                return [1, 2, 3, 4, 5];
            case 10:
                return [2, 4, 6, 8, 10];
            case 20:
                return [5, 10, 15, 20];
            case 30:
                return [10, 20, 30];
            case 40:
                return [10, 20, 30, 40];
            case 50:
                return [10, 20, 30, 40, 50];
            case 60:
                return [10, 20, 30, 40, 50, 60];
            case 80:
                return [10, 20, 30, 40, 50, 60, 70, 80];
            case 100:
                return [20, 40, 60, 80, 100];
            case 150:
                return [20, 40, 60, 80, 100, 150];
            case 200:
                return [20, 40, 60, 80, 100, 150, 200];
            case 250:
                return [20, 40, 60, 80, 100, 150, 200, 250];
            case 300:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300];
            case 350:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350];
            case 400:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400];
            default:
                return [20, 40, 60, 80, 100, 150, 200, 250, 300, 350, 400, maxHeight];
        }
    }

   static displayTicksHeightUs(maxHeight: number) {
        switch (maxHeight) {
            case 3:
                return [1, 2, 3];
            case 6:
                return [2, 4, 6];
            case 9:
                return [1, 3, 6, 9];
            case 15:
                return [3, 6, 9, 12, 15];
            case 30:
                return [6, 12, 18, 24, 30];
            case 60:
                return [15, 30, 45, 60];
            case 90:
                return [30, 60, 90];
            case 120:
                return [30, 60, 90, 120];
            case 150:
                return [30, 60, 90, 120, 150];
            case 180:
                return [30, 60, 90, 120, 150, 180];
            case 240:
                return [30, 60, 90, 120, 150, 180, 210, 240];
            case 300:
                return [60, 120, 180, 240, 300];
            case 450:
                return [60, 120, 180, 240, 300, 450];
            case 600:
                return [60, 120, 180, 240, 300, 450, 600];
            case 750:
                return [60, 120, 180, 240, 300, 450, 600, 750];
            case 900:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900];
            case 1050:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900, 1050];
            case 1200:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900, 1050, 1200];
            default:
                return [60, 120, 180, 240, 300, 450, 600, 750, 900, 1050, 1200, maxHeight];
        }
    }

   static displayTile(param: Parameter) {
        switch (param) {
            case Parameter.Score:
                return false;
            case Parameter.DistanceToTarget:
                return false;
            case Parameter.DistanceToPin:
                return false;
            default:
                return true;
        }
    }
}
export class GraphMargin {
    top: number;
    bottom: number;
    left: number;
    right: number;

    constructor(t: number, b: number, l: number, r: number) {
        this.top = t;
        this.bottom = b;
        this.left = l;
        this.right = r;
    }
}